import React, { useEffect, useState } from 'react';
import { InitialStep } from './InitialStep';
import { FinalStep } from './FinalStep';
import { FeedbackStep } from './FeedbackStep';
import { CancelationReason, INVOICE_TYPE_ISSUED } from '../../types';
import { BenefitsStep } from './BenefitsStep';
import { useTimelineData } from '../../hooks/useTimelineData';

type WizardSteps = 'preparation' | 'benefits' | 'initial' | 'feedback' | 'final';

export const CancellationWizard = () => {
  const [step, setStep] = useState<WizardSteps | null>('preparation');
  const [hasBenefitsStep, setHasBenefitsStep] = useState(false);

  const timelineData = useTimelineData();
  useEffect(() => {
    if (step === 'preparation' && timelineData.type === 'data') {
      const issuedInvoices = timelineData.data.invoicesAndBenefits.filter(
        (x) => typeof x.invoice === 'object' && x.invoice?.type === INVOICE_TYPE_ISSUED
      );
      if (timelineData.data.billingPlan.name === 'month' && issuedInvoices.length > 2) {
        setStep('benefits');
        setHasBenefitsStep(true);
      } else {
        setStep('initial');
        setHasBenefitsStep(false);
      }
    }
  }, [timelineData, step]);

  const [selectedReasons, setSelectedReasons] = useState<CancelationReason[]>([]);
  const [comment, setComment] = useState('');

  return (
    <>
      {step === 'preparation' && timelineData.type === 'component' && timelineData.statusComponent}
      {step === 'benefits' && (
        <BenefitsStep onNext={() => setStep('initial')} onCancel={() => setStep(null)} />
      )}
      {step === 'initial' && (
        <InitialStep
          hasPreviousStep={hasBenefitsStep}
          onNext={() => setStep('feedback')}
          onGoBackClicked={() => setStep(hasBenefitsStep ? 'benefits' : null)}
        />
      )}
      {step === 'feedback' && (
        <FeedbackStep
          selectedReasons={selectedReasons}
          onSelectedReasonsChanged={setSelectedReasons}
          comment={comment}
          onCommentChanged={setComment}
          onGoBackClicked={() => setStep('initial')}
          onBillingPlanCanceled={() => setStep('final')}
        />
      )}
      {step === 'final' && <FinalStep />}
    </>
  );
};
